<template>
  <v-menu v-model="options.show" :position-x="options.x" :position-y="options.y" absolute offset-y>
    <v-list>
      <v-list-item style="min-height: 20px">
        <v-list-item-icon class="mt-1 mb-1" style="align-self: auto !important;">
          <v-icon x-small>mdi-clock-time-four-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="pt-1 pb-1">
          <v-list-item-title v-text="date"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-for="(item, index) in items" :key="index" @click="item.handler" style="min-height: 20px">
        <v-list-item-icon class="mt-1 mb-1" style="align-self: auto !important;">
          <v-icon small>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="pt-1 pb-1">
          <v-list-item-subtitle>{{ item.text }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';

export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  watch: {
    'options.systemId': {
      immediate: true,
      handler(val) {
        this.setMenu(val);
      },
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapState('common/menu', ['realtime']),
    date() {
      return this.options.xAxisValue ? format(this.options.xAxisValue, 'yyyy-MM-dd HH:mm:ss') : '';
    },
  },
  methods: {
    setMenu(systemId) {
      const [{ children: realtimeMenus }] = this.realtime;
      const [{ children: menu }] = realtimeMenus.filter(m => m.name == this.options.stackType.toLowerCase());
      this.items = menu.map(m => ({
        icon: m.icon,
        text: this.$t(m.messageCode),
        handler: () => window.open(`${m.url}/${systemId}?t=${this.options.xAxisValue}&c=${this.options.sttsCode}`, '_blank'),
      }));

      // BEGIN::Modifield.by.KWShin.2026.03.30.
      // 1. 통계에서는 Load Kind를 구분하지 않고 모든 데이터를 보여주므로 exr에는 항상 '0'을 넘긴다.
      //    그러면 OWLView와 Context Analyzer 내의 SsrFilter 컴포넌트는
      //    OWLens와 System 부하를 제외하지 않고 모두 포함해서 보여준다.
      // 2. DataTargets(Element/Instance/System/Node) 컴포넌트의 props 'params'를
      //    props 'options'에 dataTargesParams라는 이름으로 전달 받게끔 수정함.
      //    dataTargetsParams에는 통계 화면에서 입력된 조건들이 모두 들어 있음.
      //    dataTargetsParams.taskType이 있는 경우, OWLView/Context Analyzer 연동 시
      //    URL Parameter 'task'에 taskType.infos.val(화면에서 선택된 task type 값이 ','로 연결된 스트링) 값을 전달함.
      const ctxtQuery = {
        dt: this.options.xAxisValue,
        sid: systemId,
        iid: this.options.instanceId ? this.options.instanceId : '',
        exr: '0',
      };
      if (this.options.dataTargetsParams.taskType) {
        ctxtQuery.task = this.options.dataTargetsParams.taskType.infos.val;
      }
      this.items[this.items.length] = {
        icon: 'mdi-layers-search',
        text: this.$t('menu.realtime.detailview.abap.analyzer'),
        handler: () => window.open(`/views/analysis/context-analyzer?${new URLSearchParams(ctxtQuery).toString()}`, '_blank'),
      };

      const owlQuery = {
        sdt: this.options.xAxisValue,
        stack: this.options.stackType,
        sid: systemId,
        iid: this.options.instanceId ? this.options.instanceId : '',
        exr: '0',
      };
      if (this.options.dataTargetsParams.taskType) {
        owlQuery.task = this.options.dataTargetsParams.taskType.infos.val;
      }
      this.items[this.items.length] = {
        icon: 'mdi-layers-triple',
        text: this.$t('menu.analstatic.analysis.owlview'),
        handler: () => window.open(`/views/analysis/owlview?${new URLSearchParams(owlQuery).toString()}`, '_blank'),
      };
      // FINISH::Modifield.by.KWShin.2026.03.30.
    },
  },
};
</script>

<style scoped>
.icon {
  margin-right: 0px;
}
.item-icon {
  height: 15px !important;
}
.item-content {
  padding: 2px 0 !important;
}
</style>
